<template>
    <div class="outfit-container">
        <div class="outfit-animation-container" :class="animationClass">
            <outfit-card :outfit="outfit" :swapProductClk="() => {}" />
            <div class="overlay" :class="{ 'overlay--like': type === 'like' }">
                <img class="overlay-icon" :src="imageUrl(overlayIcon)" />
                <h3 class="overlay-title">{{ title }}</h3>
                <h5 class="overlay-subtext">{{ subtext }}</h5>
            </div>
        </div>
        <div class="outfit-card-placeholder"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Mixins from "../../../mixins/mixins";
import OutfitCard from "../../style-selection/outfit-card.vue";

export default {
    props: {
        title: String,
        subtext: String,
        type: String,
    },
    components: {
        OutfitCard,
    },
    mixins: [Mixins],
    computed: {
        animationClass() {
            return {
                [`outfit-animation-container--${this.type}`]: true,
            };
        },
        overlayIcon() {
            switch (this.type) {
                case "like":
                    return "heart.svg";
                case "reject":
                    return "close-icon.svg";
                case "swap":
                    return "swap-white.svg";
            }
        },
        ...mapGetters({
            outfit: "onboarding/currentAnimationOutfit",
        }),
    },
};
</script>

<style lang="scss">
.outfit-animation-container {
    &--swap {
        .outfit-card {
            &-priority-1 {
                .swap-item-button {
                    z-index: 2;
                    height: 46px;
                    width: 46px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    right: 0px;
                    top: 0px;
                    .swap-item-icon-container {
                        background: radial-gradient(
                            circle,
                            #ffffff 0%,
                            #ffffff 0%,
                            #fdfdfd 11%,
                            transparent 60%
                        );
                        animation-duration: 2s;
                        animation-iteration-count: infinite;
                        animation-name: swap;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 33px;
                        height: 33px;
                    }
                    .swap-item-icon {
                        fill: #fe0176;
                        height: 21px;
                    }
                }
            }
        }
    }
}

@keyframes swap {
    0% {
        width: 33px;
        height: 33px;
    }
    30% {
        width: 46px;
        height: 46px;
    }
    70% {
        width: 33px;
        height: 33px;
    }
}
</style>

<style lang="scss" scoped>
.outfit-container {
    margin: 25px 13px;
    height: calc(100vh - 180px);
    position: relative;
    @media screen and (min-height: 660px) {
        margin-top: 35px;
        max-height: 470px;
    }
    @media screen and (min-height: 800px) {
        margin-top: 60px;
        max-height: 550px;
    }
    .outfit-animation-container {
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
        height: 100%;
        &--like {
            animation-name: swiperight;
        }
        &--reject {
            animation-name: swipeleft;
        }
        .overlay {
            border-radius: 20px;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            color: white;
            background-color: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding: 0 30px;
            text-align: center;
            z-index: 1;
            &--like {
                background-color: rgba(248, 174, 171, 0.7);
                .overlay-icon {
                    width: 50px;
                }
            }
            &-title {
                font-size: 24px;
                margin-bottom: 30px;
            }
            &-subtext {
                font-size: 16px;
                font-weight: normal;
            }
            &-icon {
                width: 40px;
                margin-bottom: 40px;
            }
        }
    }

    .outfit-card-placeholder {
        border-radius: 20px;
        border: 1px solid #f0f0f0;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: -1;
    }
}

@keyframes swiperight {
    0% {
        transform: translateX(0%) rotate(0deg);
    }
    30% {
        transform: translateX(10%) rotate(10deg);
    }
    70% {
        transform: translateX(0%) rotate(0deg);
    }
}

@keyframes swipeleft {
    0% {
        transform: translateX(0%) rotate(0deg);
    }
    30% {
        transform: translateX(-10%) rotate(-10deg);
    }
    70% {
        transform: translateX(0%) rotate(0deg);
    }
}
</style>
